import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';
import { EEARType } from '../model/enum/reporting/eear-type.enum';
import { EVALUATOR_NAME_SORT_FIELD } from '../reporting/evaluator-completion-report/constants/evaluator-completion-report-sort.constants';

export const ReportingLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    componentsReport: LazyLoadedStates,
    observationSummaryReport: LazyLoadedStates,
    growthAndStrengthsReport: LazyLoadedStates,
    educatorEffectivenessAnnualReport: LazyLoadedStates,
    eearIndividual: LazyLoadedStates,
    eearBuilding: LazyLoadedStates,
    ratingFormCompletionReport: LazyLoadedStates,
    ratingFormMissingFormsReport: LazyLoadedStates,
    evaluatorCompletionReport: LazyLoadedStates,
}>({
    base: {
        name: 'authenticated.reporting',
        url: '/reporting',
    },
    componentsReport: {
        name: 'authenticated.reporting.components-report',
        url: '/components-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    observationSummaryReport: {
        name: 'authenticated.reporting.observation-summary-report',
        url: '/observation-summary-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    growthAndStrengthsReport: {
        name: 'authenticated.reporting.growth-and-strengths-report',
        url: '/growth-and-strengths-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    educatorEffectivenessAnnualReport: {
        name: 'authenticated.reporting.eear',
        url: '/eear?ratingFormType&schoolYear&bid&orderBy&ascending',
        abstract: true,
        params: {
            ratingFormType: {
                raw: true,
                type: 'string'
            },
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    eearBuilding: {
        name: 'authenticated.reporting.eear.building',
        url: '/building',
        params: {
            eearType: {
                raw: true,
                type: 'string',
                value: `${EEARType.BUILDINGS}`
            }
        }
    },
    eearIndividual: {
        name: 'authenticated.reporting.eear.individual',
        url: '/individual',
        params: {
            eearType: {
                raw: true,
                type: 'string',
                value: `${EEARType.INDIVIDUALS}`
            }
        }
    },
    ratingFormCompletionReport:{
        name: 'authenticated.reporting.rating-form-completion-report',
        url: '/rating-form-completion-report?schoolYear&ratingType&evaluationIntervals&signatureFilterBy&filterBySearchBy&bid',

    },
    ratingFormMissingFormsReport:{
        name: 'authenticated.reporting.rating-form-missing-forms-report',
        url: '/rating-form-missing-forms-report?schoolYear&bid&filterBySearchBy',
    },
    evaluatorCompletionReport: {
        name: 'authenticated.reporting.evaluator-completion-report',
        url: '/evaluator-completion-report?evaluatorId&bid&startDate&endDate&orderBy&ascending',
        params: {
            evaluatorId: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'string',
                value: ''
            },
            bid: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'int',
                array: true,
                value: []
            },
            startDate: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'string',
                value: ''
            },
            endDate: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'string',
                value: ''
            },
            orderBy: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'string',
                value: EVALUATOR_NAME_SORT_FIELD
            },
            ascending: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'bool',
                value: true
            }
        }
    },

},
    () => import('src/app/reporting/reporting.module').then((result: { ReportingModule: any }) => result.ReportingModule)
);
